'use strict';

const Moment = require('moment');
const Pagination = require('framework/domain/value/pagination');
const ReadMoreCollection = require('framework/domain/collection/readmore-collection');

module.exports = class TaskCollection extends ReadMoreCollection {
    constructor(models, options) {
        super(models, options);

        this._key = options.key;
        this._repository = options.repository;

        this.listenTo(this._repository, 'add', task => {
            if(this.isBelongToSomePage(task)) {
                this.add(task);
            }
        });
        this.listenTo(this._repository, 'add:count', task => {
            if(this.isBelongToCollection(task)) {
                this.addTotalCount(1);
            }
        });
        this.listenTo(this._repository, 'update', task => {
            this.trigger('change:update', task);
        })
    }

    // createdAt でソートした後、state でソートする
    model2number(model) {
        const time = Moment(model.getCreatedAt()).unix();

        // state が done の場合は unix time に比べて十分大きい値を足す
        if(model.isDone()) {
            return - time + 1000000000;
        }

        return - time;
    }

    isBelongToCollection(model) {
        return model.isRelatedTo(this._key);
    }

    fetch(limit, cursor) {
        return this._repository.fetchByKey(this._key, limit, cursor)
            .then(result => {
                const pagination = result.pagination;
                return {
                    models: result.models,
                    pagination: new Pagination(
                        pagination.totalCount,
                        pagination.prevCursor,
                        pagination.prevMore,
                        pagination.nextCursor,
                        pagination.more
                    )
                }
            });
    }

    hasUnfinishedTask() {
        // Collectionの中には、TaskとReadMoreが混在しているので、 isUnfinished() の存在チェックを行う必要がある
        return this.filter(task => {
            return task.isUnfinished && task.isUnfinished();
        }).length >= 1;
    }
};



// WEBPACK FOOTER //
// ./communication/domain/collection/task.js